import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'
import './vue-grid-layout.css'
import { setTokenFromPostMessage } from './utils/tokenHandler.js'

// Listen for token from parent window (when opened via openInNewTab)
window.addEventListener('message', (event) => {
  // Only accept messages from same origin
  if (event.origin !== window.location.origin) {
    return
  }
  
  if (event.data && event.data.type === 'DASHBOARD_TOKEN') {
    setTokenFromPostMessage(event.data.token)
    
    // Trigger a page reload or re-initialization if needed
    // The token will be picked up on next getTokenFromURL call
    if (window.location.search.includes('fullscreen=true')) {
      // Dispatch event to notify components that token is available
      window.dispatchEvent(new CustomEvent('token-received'))
    }
  }
})

const app = createApp(App)
app.use(router)
app.mount('#app')
